
import { useCallback, useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import {
    Breadcrumbs,
    CommonSelect,
    CstmPagination
} from "../../../../../components/Common/Common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, successMessageToast } from "helpers/common";
import {
    SUPPORT_STAFF_CLIENT,
    TASK_PLAN_EDIT,
} from "config/paths";
import { GRADE_OPTIONS, TASK_STATUS_OPTIONS_V2 } from "config/constants";
import { useDispatch, useSelector } from "react-redux";
import { initialFilterState, supportStaffTaskListFilter } from "store/slices/filter";
import { usePersistentState } from "hooks/usePersistentState";
import TableLayoutV2 from "components/TableLayoutV2";
import { Star } from "react-feather";
import { useNavigate, useParams } from "react-router-dom";
import { useDeleteTaskPlanMutation, useFavouriteTaskPlanClientMutation } from "store/services/V2/TaskPlan";
import { useGetSupportStaffTaskslistQuery } from "store/services/V2/supportStaff";
import { SearchIcon, ThreeDotsMenuIcon } from "Assets/icons/v2";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { debounce } from "lodash";

const SupportStaffTask = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams()

    const [showModal, setShowModal] = useState(false);
    const [currentEntry, setCurrentEntry] = useState(null); 

    const [currentPage, setCurrentPage] = usePersistentState("supporttask:page", 1);
    const [pageSize, setPageSize] = useState(10);
    const filter = useSelector(state => state?.filter?.supportStaffTaskListFilter);

    const { data, isLoading, isError, isFetching, refetch } = useGetSupportStaffTaskslistQuery(
        { page: currentPage, id, limit: pageSize, ...filter },
        { refetchOnMountOrArgChange: true }
    );
    const [deleteTaskPlan, { isLoading: deleteLoading }] = useDeleteTaskPlanMutation()
    const supportStaffInfo = `${data?.support_staff?.firstname} ${data?.support_staff?.lastname}`;
    // const supportStaffTaskData = data?.records?.flatMap(record => record?.supportStaffClients || []) || [];

    const supportStaffTaskData = data?.records
    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);
    const [favouriteTaskPlan, { isLoading: favouriteTaskLoading }] = useFavouriteTaskPlanClientMutation()


    const column = [
        {
            head: <div onClick={() => dispatch(supportStaffTaskListFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "id", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
            accessor: "is_favorite",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => {
                    e.stopPropagation();
                    handleFavouriteReport(item?.task_plan_id, item?.client_id, item?.is_favorite ? 0 : 1)
                }}>{item?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
            ),
        },

        {
            head: "CLIENT",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <span>{item?.client?.client_detail?.firstname} {item?.client?.client_detail?.lastname}</span>
            ),
        },

        {
            head: "GR",
            accessor: "client_grade",
            isComponent: true,
            sorter: true,
            width: "100%",
        },


        {
            head: "DATE",
            accessor: "date",
            isComponent: true,
            sorter: true,
            component: (item) => dateFormat(item?.date, "MMM DD, YYYY"),
        },

        // {
        //     head: "DISC",
        //     accessor: "",
        //     component: (item, ind) => (
        //         <>
        //             <span className={`discipline-${user?.therapist_discipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{user?.therapist_discipline?.assign_term}</span>
        //         </>
        //     ),
        // },

        // {
        //     head: "PLAN NAME",
        //     accessor: "plan_name",
        //     isComponent: true,
        //     sorter: true,
        //     width: "100%",
        //     component: (item) => (
        //         <span>{item?.taskPlan?.plan_name}</span>
        //     ), 
        // }, 
        {
            head: "Status",
            accessor: "status",
            isComponent: true,
            sorter: true,
            component: (item) => (
                <span>{TASK_STATUS_OPTIONS_V2?.find((list) => list?.value === item?.status)?.label}</span>
            ),
        },
        {
            head: "",
            accessor: "",
            isComponent: true,
            component: (item, index) => (
                item?.status != "discharged" &&
                <Dropdown
                    onClick={(e) => e.stopPropagation()}
                >
                    <Dropdown.Toggle
                        variant="transparent"
                        className="p-0 border-0 text-dark w-100"
                        id="dropdown-basic"
                    >
                        <ThreeDotsMenuIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
                        <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                            <h5 onClick={(e) => {

                                e.stopPropagation();
                                console.log("item", item)
                                navigate(TASK_PLAN_EDIT.replace(":id", item?.id));
                            }} className="cursor-pointer proxima">
                                Edit
                            </h5>
                            <h5 onClick={(e) => {
                                e.stopPropagation();
                                console.log(item)
                                setCurrentEntry(item)
                                setShowModal(true)
                            }} className="cursor-pointer proxima">
                                Delete
                            </h5>

                        </ul>
                    </Dropdown.Menu>
                </Dropdown>
            ),
        },
    ];

    const handleFilterChange = (key) => (value) => {
        dispatch(supportStaffTaskListFilter({ ...filter, [key]: value }))
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handleSearchChange = useCallback(debounce((value) => {
        handleFilterChange("search")(value);
    }, 500), [handleFilterChange, 500]);

    const resetFilter = () => {
        dispatch(supportStaffTaskListFilter(initialFilterState.supportStaffTaskListFilter));
        setCurrentPage(1)
    };

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handlePageSizeChange = (e) => {
        setPageSize(parseInt(e.target.value, 10));
        setCurrentPage(1); // Reset to first page when page size changes
    };

    const handleGetRowColor = (item) => {
        if (item?.status == "pending") {
            return "rowYellow";
        }
        else if (item?.status == "inactive") {
            return "rowGray";
        }
    }

    const handleFavouriteReport = async (id, clientId, favorite) => {
        const data = {
            favorite
        }
        try {
            await favouriteTaskPlan({ data, id, clientId }).unwrap()
        } catch (error) {
            console.error('error making the client favourite: ', error)
        }
        refetch()
    }


    const handleDelete = async () => {
        try {
            setShowModal(false);
            const result = await deleteTaskPlan({ id: currentEntry?.id }).unwrap();
            if (result?.status === "success") {
                successMessageToast(result?.message);
            }

        } catch (err) {
            console.error("error deleting template", err);
        };
        refetch()
    };

    return (
        <>
            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                confirmHandler={handleDelete}
                type="delete"
            />
            <section className="client position-relative py-4">
                <Container fluid>
                    {isLoading ? <div style={{ height: "200px" }}>  <LoadingIndicator /></div> : <Row>
                        <div className="px-3">
                            <Breadcrumbs items={[{ label: "Support Staff", path: "/client/support-staff" }, { label: supportStaffInfo, path: "" }]} style={{ fontSize: "14px" }} />
                        </div>
                        <Col lg="12" className="my-2">
                            <div className="left classroom-conslutation d-flex justify-content-between align-items-end">
                                <h6 className="m-0 fw-bold main-head themeBlue"> {supportStaffInfo}</h6>
                            </div>
                            <Row className="d-flex justify-content-end reports-v2 ">
                                <Col xs="3" xl='2'>
                                    <div className="d-flex w-100 align-items-center gap-3">
                                        <label className="discharge-screen-label mb-0">Grade</label>
                                        <CommonSelect
                                            placeholder={"Select"}
                                            option={GRADE_OPTIONS}
                                            onChange={(e) => handleFilterChange("grade")(e)}
                                            value={filter?.grade}
                                            // onInputChange={(val) => handleSearch(val)}
                                            isFilterV2
                                            isClearable
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: "100%", // ✅ Ensures the whole Select container is full width
                                                }),
                                            }}
                                        // isLoading={schoolsLoading}
                                        />
                                    </div>
                                </Col>

                                <Col xs="3" xl='2'>
                                    <div className="d-flex w-100 align-items-center gap-3">
                                        <label className="discharge-screen-label mb-0">Status</label>
                                        <CommonSelect
                                            placeholder={"Select"}
                                            option={TASK_STATUS_OPTIONS_V2}
                                            onChange={(e) => handleFilterChange("status")(e)}
                                            value={filter?.status}
                                            // onInputChange={(val) => handleSearch(val)}
                                            isFilterV2
                                            isClearable
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: "100%", // ✅ Ensures the whole Select container is full width
                                                }),
                                            }}
                                        // isLoading={schoolsLoading}
                                        />
                                    </div>
                                </Col>

                                <Col xs="4">
                                    <div className="d-flex align-items-center gap-3 search-input-filter-v2 readonly-box">
                                        <input
                                            onChange={(e) => handleSearchChange(e.target.value)}
                                            className="border-0 shadow-none h-auto w-100"
                                            placeholder="Search..."
                                            defaultValue={filter?.search}
                                            style={{ outline: "none" }}
                                        />
                                        <SearchIcon />
                                    </div>
                                </Col>
                            </Row>

                            <div className="table-outer mt-3">
                                {isError ? (
                                    <ErrorComponent />
                                ) : (
                                    <>
                                        {(isFetching || favouriteTaskLoading || deleteLoading) && <LoadingOverlay />}
                                        <TableLayoutV2
                                            data={supportStaffTaskData}
                                            column={column}
                                            filter={filter}
                                            url={null}   // disable internal navigation
                                            handleRowClick={(row) => {
                                                navigate(
                                                    SUPPORT_STAFF_CLIENT.replace(
                                                        "/:id/:taskPlanId/:clientId",
                                                        `/${id}/${row?.id}/${row?.client_id}`
                                                    )
                                                );
                                            }}

                                            handleSort={handleFilterChange("sort")}
                                            handleGetRowColor={handleGetRowColor}
                                        />
                                    </>
                                )}
                                <CstmPagination
                                    totalPages={totalPages}
                                    className={'paginationV2'}
                                    activePage={currentPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        </Col>
                    </Row>}
                </Container>
            </section >
        </>
    );
};


export default SupportStaffTask;
